// ----- announcement swiper slider ------

$(document).ready(function(){
  function initSwiper() {
       swiper = new Swiper('.announcement_slid', {
        loop: true,
        slidesPerView: 'auto',
        autoplay: {
          delay: 5000,
          disableOnInteraction: true
        },
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
       breakpoints: {
          640: {
            slidesPerView:'auto',
          },
          1024: {
            slidesPerView:'auto',
          }
        }
      });
  }
  $(window).resize(function() {
    setTimeout(function(){
    swiper.destroy();
    initSwiper();
      },500);
   });
initSwiper();
});


// code for announcementbar dragg

// $(document).ready(function(){
//   function initSwiper() {
//     swiper = new Swiper('.announcement_slid', {
//       loop: true,
//       slidesPerView: 'auto',
//       autoplay: {
//         delay: 5000,
//         disableOnInteraction: true
//       },
//       centeredSlides: true,
//       navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//       },
//       touchRatio: 1, // Default is 1, but you can adjust if needed
//       touchReleaseOnEdges: true, // Allows releasing swipe at edges
//       breakpoints: {
//         640: {
//           slidesPerView: 'auto',
//         },
//         1024: {
//           slidesPerView: 'auto',
//         }
//       }
//     });
//   }

//   var initialized = false;
  
//   $(window).resize(function() {
//     if (!initialized) {
//       initSwiper();
//       initialized = true;
//     } else {
//       swiper.update(); // Update Swiper on resize instead of destroying it
//     }
//   });

//   initSwiper();
// });

